import { render, staticRenderFns } from "./IrrigationPlan.vue?vue&type=template&id=6028be65&scoped=true&"
import script from "./IrrigationPlan.vue?vue&type=script&lang=ts&"
export * from "./IrrigationPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6028be65",
  null
  
)

export default component.exports